// UK-format postcode validation. covers Guernsey, Jersey and the Isle of Man (they use UK-format postcodes); 
// GIR 0AA is special - cased. Empty passes so `nullable`/`required` govern presence separately.
export const UK_POSTCODE_REGEX = /^(?:([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2}))$/;

export const isValidUkPostcode = (value: unknown): boolean => {
    if (value === null || value === undefined) return true;
    const v = String(value).trim();
    if (v === '') return true;
    return UK_POSTCODE_REGEX.test(v);
};
